import { create } from 'zustand';

import { ImportFileState } from '@/modules/onboarding/common/import-entities-modal/types/common';

interface ImportMembersState<TError> {
  file: File | null;
  importState: ImportFileState;
  previewErrorOpen: boolean;
  parsedMembersCount: number;
  importErrors: TError[];
  setFile: (file: File | null) => void;
  setImportState: (importState: ImportFileState) => void;
  setPreviewErrorOpen: (previewErrorOpen: boolean) => void;
  setParsedMembersCount: (count: number) => void;
  setImportErrors: (errors: TError[]) => void;
  resetState: () => void;
}

export const useImportEntitiesStore = create<ImportMembersState<any>>(set => ({
  file: null,
  importState: ImportFileState.IDLE,
  previewErrorOpen: false,
  parsedMembersCount: 0,
  importErrors: [],
  setFile: (file: File | null) => set({ file }),
  setImportState: (importState: ImportFileState) => set({ importState }),
  setPreviewErrorOpen: (previewErrorOpen: boolean) => set({ previewErrorOpen }),
  setParsedMembersCount: (count: number) => set({ parsedMembersCount: count }),
  setImportErrors: (errors: any[]) => set({ importErrors: errors }),
  resetState: () =>
    set({
      file: null,
      importState: ImportFileState.IDLE,
      previewErrorOpen: false,
      parsedMembersCount: 0,
      importErrors: [],
    }),
}));
